<template>
  <div
    class="msrp-popup-wrap"
    :class="{ hidden: !$store.state.showInfoPopup }"
    v-on:click="hidePopup()"
  >
    <div class="msrp-content" v-on:click="$event.stopPropagation()">
      <button class="desktop-close" v-on:click="hidePopup()" aria-label="Close">
        <img aria-hidden="true" src="./../assets/icons/close.svg" />
      </button>
      <article>
        <section>
          <p>
            {{ getInfoPopupText }}
          </p>
        </section>
      </article>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SimpleInfoPopup',
  methods: {
    hidePopup() {
      this.$store.commit('hideInfoPopup', false);
    },
  },
  computed: {
    ...mapGetters(['getInfoPopupText']),
  },
};
</script>
<style scoped lang="scss">
.msrp-popup-wrap {
  position: absolute;
  z-index: 61;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(3px);
  &.hidden {
    display: none;
  }
  .msrp-content {
    position: relative;
    width: calc(100% - 2em);
    max-width: 23em;
    background-color: $navy;
    box-shadow: 0 3px 24px rgba(0, 0, 0, 0.5);
    overflow: hidden;
    button.desktop-close {
      position: absolute;
      top: 1em;
      right: 0;
      display: block;
      background: transparent;
      border: none;
      opacity: 0.5;
      img {
        width: 1.3em;
      }
      &:hover {
        opacity: 0.8;
      }
    }
    article {
      padding: 1.5em 1em;
      section {
        margin-top: 3em;
        padding: 0.5em 0;
        p {
          color: white;
        }
      }
    }
  }
}
</style>
